
import api from '../../api/index.js'

const state = {

}

const getters = {

}

const actions = {
    // 获取纪念堂详情
    GetMourningHallMourningHallSearch({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/MourningHall/MourningHallSearch',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
}

const mutations = {

}

export default {
    state,
    getters,
    actions,
    mutations
}




